import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  EventsService,
  NoalGlobalData,
} from "../../../_services/eventsServices/events.service";
import {
  FormArray,
  FormControl,
  FormGroup,
  FormGroupDirective,
} from "@angular/forms";
import { createParentEventFormQuestionsContent } from "../create-parent-event-form-questions-content/create-parent-event-form-questions-content";

import { GenericFormComponent } from "../../../form/generic-form/generic-form.component";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { FormQuestion } from "../event-page-models/form-question";
import { Circle, Layer } from "../event-page-models/noal.models";
import { ChildEventPriceChange } from "../event-page-models/child-event";
import { sleep } from "../../../_helpers/sleep";
import { filter } from "rxjs/operators";
import { EventFormInitialData } from "../event-page-models/event-form-initial-data";
import { EventSerializerService } from "../../../_services/eventsServices/eventSerializer.service";
import { EventOrgan } from "../create-parent-event-form-pricing-nests/create-parent-event-form-pricing-nests.component";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { GenericModalComponent } from "../../../form/generic-app-modal/generic-modal.component";
import { EventFormCustomFormType } from "../event-page-models/event-form-custom-form-type";
import { SpecialTypeEventsService } from "../../../_services/eventsServices/specialTypeEvents.service";
import { EventFormStatusEnum } from "../event-page-models/event-form-status.enum";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { EventCollectionItem } from "../event-page-models/event-collection-item";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { AbstractService } from "../../../_services/abstract/abstract.service";

@Component({
  selector: "create-parent-event-form-pricing-list-row",
  templateUrl: "./create-parent-event-form-pricing-row.component.html",
  styleUrls: [
    "create-parent-event-form-pricing-row.component.scss",
    "../../../form/generic-form/generic-form.component.scss",
  ],
  animations: [
    trigger("openClose", [
      state(
        "open",
        style({
          maxHeight: "3600px",
          overflow: "visible",
          opacity: 1,
        })
      ),
      state(
        "closed",
        style({
          height: "1px",
          opacity: 0,
          overflow: "hidden",
        })
      ),

      transition("open => closed", [animate("0.2s")]),
      transition("* => open", [animate("0.2s")]),
      transition("closed => open", [animate("0.2s")]),
    ]),
    trigger("openCloseData", [
      state(
        "open",
        style({
          maxHeight: "1000px",
          overflow: "visible",
          opacity: 1,
        })
      ),
      state(
        "closed",
        style({
          maxHeight: "1px",
          opacity: 0,
          overflow: "hidden",
        })
      ),

      transition("open => closed", [animate("0.2s")]),
      transition("* => open", [animate("0.2s")]),
      transition("closed => open", [animate("0.2s")]),
    ]),
  ],
})
export class CreateParentEventFormPricingRowComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  public initialSelectedOrgans: EventOrgan[] = [];
  public readonly MaagalList: Circle[] = [];
  public readonly LayersList: Layer[] = [];
  public readonly PriceChangeList: ChildEventPriceChange[] = [];
  public noalGlobalData: NoalGlobalData;
  public childEventAdvancedData: FormQuestion[] =
    SpecialTypeEventsService.deepCopyFormQuestions(
      createParentEventFormQuestionsContent.childEventAdvancedDetailsQuestions
    );
  public abstractPricingData: BehaviorSubject<{
    nests: string;
    layers: string;
    closedToMembers: boolean;
  }> = new BehaviorSubject<{
    nests: string;
    layers: string;
    closedToMembers: boolean;
  } | null>(null);
  @Output() public deletePricingRowEmit: EventEmitter<number> =
    new EventEmitter<number>();
  public childEventAdvancedDetailsFormGroup: FormGroup | null = null;
  public childPricingFormGroup: FormGroup;
  @Input("eventFormCustomFormType")
  public eventFormCustomFormType: EventFormCustomFormType =
    EventFormCustomFormType.common;
  public advanceDataOpen: boolean = false;
  @Input("pricingIndex") public pricingIndex: { name: string; order: number } =
    { name: "", order: 0 };
  @ViewChild("priceHeader") public priceHeader: ElementRef;
  @ViewChild("priceInputElement") public priceInputElement: ElementRef;
  @Input("rowOpenByDefault") public advancePricingRowOpen: boolean = false;
  @Input("isOnlyRowInParentEvent") public isOnlyRowInParentEvent: boolean =
    false;
  protected readonly SessionManagerService = SessionManagerService;
  private formStatus: EventFormStatusEnum = EventFormStatusEnum.New;

  constructor(
    private eventService: EventsService,
    private inputFormGroup: FormGroupDirective,
    private modalService: NgbModal,
    private sessionManagerService: SessionManagerService,
    private abstractService: AbstractService
  ) {}

  //can_be_deleted;
  public get showPricingHeader() {
    return this.eventFormCustomFormType !== EventFormCustomFormType.Michlol;
  }

  public get showPricingChanges() {
    return this.eventFormCustomFormType !== EventFormCustomFormType.Michlol;
  }

  public get showNoObligatoryCommentChanges() {
    return this.eventFormCustomFormType !== EventFormCustomFormType.Michlol;
  }

  public get showAdvancedOptions() {
    return !(
      this.eventFormCustomFormType === EventFormCustomFormType.Michlol &&
      this.formStatus === EventFormStatusEnum.New
    );
  }

  get eventMaagalControls() {
    return (this.childPricingFormGroup.get("eventFormMaagal") as FormArray)
      .controls as FormControl[];
  }

  get eventFormPriceChangesControls() {
    return (
      this.childPricingFormGroup.get("eventFormPriceChanges") as FormArray
    ).controls as FormGroup[];
  }

  get eventLayersControls() {
    return (this.childPricingFormGroup.get("eventFormLayers") as FormArray)
      .controls as FormControl[];
  }

  get canDeletePricing() {
    return (
      !this.isOnlyRowInParentEvent &&
      (this.childPricingFormGroup.get("can_be_deleted").value as boolean)
    );
  }

  public updateAbstractPricingData() {
    const organs = this.childPricingFormGroup.get("organs")
      .value as EventOrgan[];
    const layers = (this.childPricingFormGroup.get("layers") as FormArray)
      .value as Array<{
      layerName: string;
      layerId: number;
      chosen: boolean;
    }>;

    const advanced = this.childEventAdvancedDetailsFormGroup.value as any;
    const closedToMembersChildEvent =
      advanced.closedToMembersChildEvent || false;
    const nestsAsText = this.abstractService.getOrgansAsText(organs);
    const layersAsText = this.abstractService.getLayersAsText(layers);

    this.abstractPricingData.next({
      nests: nestsAsText,
      layers: layersAsText,
      closedToMembers: closedToMembersChildEvent as boolean,
    });
  }

  public customFormQuestionsModifier(
    formQuestions: FormQuestion[],
    typeOfQuestion: "childEventAdvancedDetails"
  ): FormQuestion[] {
    const res = SpecialTypeEventsService.specialEventsFormQuestionsModifier(
      formQuestions,
      typeOfQuestion,
      this.eventFormCustomFormType
    );

    return res;
  }

  public ngOnInit(): void {
    this.initPage().then();
  }

  public async forceSetOpenClose(open: boolean) {
    const wasOpen = this.advancePricingRowOpen;
    this.advancePricingRowOpen = open;

    if (open && this.priceHeader) {
      await sleep(250);
      this.priceHeader.nativeElement.scrollIntoView({ behavior: "smooth" });
    } else if (wasOpen && !open) {
      this.priceHeader.nativeElement.scrollIntoView({ behavior: "instant" });
    }
  }

  public openClosePricingAdvanced() {
    this.advancePricingRowOpen = !this.advancePricingRowOpen;
  }

  public ngAfterViewInit() {}

  public ngOnDestroy(): void {}

  public submit() {}

  public openCloseAdvancedData() {
    this.advanceDataOpen = !this.advanceDataOpen;
  }

  public async updatePriceChanges(
    action: "add" | "updateFromLoad" | "remove" | "updateData" | "patchNew",
    priceChange?: ChildEventPriceChange
  ) {
    if (this.childPricingFormGroup) {
      await sleep(100);
    }
    const formArr = this.childPricingFormGroup.get(
      "eventFormPriceChanges"
    ) as FormArray;

    const priceChangesFormArray = this.childPricingFormGroup.get(
      "priceChanges"
    ) as FormArray;
    switch (action) {
      case "updateFromLoad":
        break;
      case "updateData":
        await sleep(50);
        priceChangesFormArray.patchValue(formArr.controls.map((c) => c.value));
        break;
      case "add":
        if (!priceChange) {
          const minimumId = Math.min(
            -1,
            ...this.PriceChangeList.map((p) => p.id)
          );
          priceChange = {
            priceChangeNewPrice: 0,
            priceChangeDate: null,
            id: minimumId - 1,
          };
        }

        this.PriceChangeList.push(priceChange);
        const newPricing: FormGroup = new FormGroup({
          id: new FormControl(priceChange.id),
          priceChangeDate: new FormControl(priceChange.priceChangeDate),
          priceChangeNewPrice: new FormControl(priceChange.priceChangeNewPrice),
        });
        formArr.controls.push(newPricing);

        break;
      case "patchNew":
        this.PriceChangeList.push(priceChange);
        const newPatchPricing: FormGroup = new FormGroup({
          id: new FormControl(priceChange.id),
          priceChangeDate: new FormControl(priceChange.priceChangeDate),
          priceChangeNewPrice: new FormControl(priceChange.priceChangeNewPrice),
        });
        formArr.controls.push(newPatchPricing);
        await this.updatePriceChanges("updateData");

        break;
      case "remove":
        const controlIndex: number = this.PriceChangeList.indexOf(priceChange);
        formArr.removeAt(controlIndex);
        this.PriceChangeList.splice(controlIndex, 1);
        await sleep(50);
        priceChangesFormArray.patchValue(formArr.controls.map((c) => c.value));
        break;
    }
  }

  public getIsDevelopmentMode() {
    return this.sessionManagerService.isDevModeActive();
  }

  public deletePricingRow($event) {
    $event.stopPropagation();
    $event.stopImmediatePropagation();
    if (this.canDeletePricing) {
      this.deletePricingRowEmit.emit(this.pricingIndex.order);
      return;
    }
    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    const text = `  ניתן  למחוק  את  התמחורלא  `;

    modalRef.componentInstance.modalOptions = {
      approveOption: "אישור",
      cancelOption: "",
      modalHeader: "לא קיים",
      modalText: text,
      onlyApprove: true,
    };
    modalRef.result.then((res) => {});
  }

  public async circleClicked() {
    await sleep(50);
    let index = 0;
    const circleValues: Circle[] = [];

    for (const control of this.eventMaagalControls) {
      if (!this.MaagalList[index]) {
        continue;
      }
      const circle: Circle & { chosen: boolean } = {
        name: this.MaagalList[index].name,
        circleId: this.MaagalList[index].circleId,
        code: this.MaagalList[index].code,
        chosen: control.value,
        has_add_permission: true,
      };
      circleValues.push(circle);

      index++;
    }

    (this.childPricingFormGroup.get("circles") as FormArray).patchValue(
      circleValues.map((c) => ({ ...c }))
    );
  }

  public async layerClicked() {
    await sleep(50);
    let index = 0;
    const layersValues = [];

    for (const control of this.eventLayersControls) {
      if (!this.LayersList[index]) {
        continue;
      }
      const layer = {
        layerName: this.LayersList[index].layerName,
        layerId: this.LayersList[index].layerId,
        chosen: control.value,
      };
      layersValues.push(layer);

      index++;
    }

    (this.childPricingFormGroup.get("layers") as FormArray).setValue(
      layersValues
    );
    this.updateAbstractPricingData();
  }

  public trackByFn(index: any, item: any) {
    return index;
  }

  public updateSelectedOrgans($event: EventOrgan[]) {
    const clearFormArray = (formArray: FormArray) => {
      while (formArray.length !== 0) {
        formArray.removeAt(0);
      }
    };
    const organsFormArray = this.childPricingFormGroup.get(
      "organs"
    ) as FormArray;
    clearFormArray(organsFormArray);
    $event.forEach((organ) => organsFormArray.push(new FormControl(organ)));
    this.updateAbstractPricingData();
  }

  public disableWheelPriceChange($event: WheelEvent) {
    this.priceInputElement.nativeElement.blur();
  }

  private async initPage() {
    this.eventService.eventFormInitialData$
      .pipe(filter((data) => !!data))

      .subscribe((initData) => {
        if (this.childPricingFormGroup) {
          return;
        }
        this.buildForm(initData).then();
        if (
          +initData.eventFormParentEventData.id > 0 ||
          initData.formStatus === EventFormStatusEnum.Copy
        ) {
          this.updateInitialSelectedOrgans(initData);
        }
      });
  }

  private updateChildEventAdditionalDetailsWithCollectionList(
    eventCollection: EventCollectionItem[]
  ) {
    this.childEventAdvancedData.forEach((q) => {
      if (q.fieldName !== "eventCollection") {
        return;
      }
      q.selectItems = eventCollection.map((evType) => {
        return {
          key: evType.id.toString(),
          text: evType.name,
          customValue: null,
          icon: null,
        };
      });
    });
  }

  private async buildForm(
    eventFormInitData: EventFormInitialData
  ): Promise<void> {
    this.formStatus = eventFormInitData.formStatus;
    this.childPricingFormGroup = this.inputFormGroup.form;

    this.childEventAdvancedDetailsFormGroup =
      GenericFormComponent.buildFormGroup(this.childEventAdvancedData);
    this.childEventAdvancedDetailsFormGroup.statusChanges.subscribe(
      (changes) => {
        this.updateAbstractPricingData();
      }
    );

    const controlsToAddToForm = {
      id: new FormControl(-1),
      eventPrice: new FormControl(""),
      eventFormMaagal: new FormArray([]),
      eventFormLayers: new FormArray([]),
      eventFormPriceChanges: new FormArray([]),
      organs: new FormArray([]),
      layers: new FormArray([]),
      circles: new FormArray([]),
      priceChanges: new FormArray([]),
      childEventAdvancedDetails: this.childEventAdvancedDetailsFormGroup,
      can_be_deleted: new FormControl(true),
    };

    // tslint:disable-next-line:forin
    for (const controlName in controlsToAddToForm) {
      this.childPricingFormGroup.setControl(
        controlName,
        controlsToAddToForm[controlName]
      );
    }

    this.noalGlobalData =
      EventSerializerService.serializeServerDataToNoalGlobalData(
        eventFormInitData.eventFormNoalData.kehilot,
        eventFormInitData.eventFormNoalData.grades,
        eventFormInitData.eventFormNoalData.ken_collections
      );
    const allCircles = this.noalGlobalData.circles;
    this.eventMaagalControls.push(
      ...allCircles.map((c) => new FormControl(""))
    );
    this.MaagalList.push(...allCircles);

    const allLayers = this.noalGlobalData.layers;
    this.eventLayersControls.push(
      ...allLayers.map((c) => new FormControl(false))
    );
    (this.childPricingFormGroup.get("layers") as FormArray).controls.push(
      ...allLayers.map((c) => new FormControl({ ...c, value: false }))
    );
    (this.childPricingFormGroup.get("circles") as FormArray).controls.push(
      ...allCircles.map((c) => new FormControl({ ...c, value: false }))
    );
    this.LayersList.push(...allLayers);
    this.updateChildEventAdditionalDetailsWithCollectionList(
      eventFormInitData.eventFormNoalData.eventCollection
    );
  }

  private updateInitialSelectedOrgans(initData: EventFormInitialData) {
    if (
      !initData.eventFormParentEventData.child_events[this.pricingIndex.order]
    ) {
      return;
    }
    const currentPricingKehilot =
      initData.eventFormParentEventData.child_events[this.pricingIndex.order]
        .kehilot;

    const onlySelectedOrgans = JSON.parse(
      JSON.stringify(currentPricingKehilot)
    ).filter((c) => true);
    onlySelectedOrgans.forEach((c) => {
      c.mehozot.forEach((m) => {
        m.kenim = m.kenim.filter((k) => k.is_selected);
      });
      c.mehozot = c.mehozot.filter((m) => m.kenim.length);
    });
    const selectedData =
      EventSerializerService.serializeServerDataToNoalGlobalData(
        onlySelectedOrgans,
        [],
        []
      );

    const nestsAsOrgans: EventOrgan[] = selectedData.nests.map((nest) => ({
      code: nest.code,
      id: nest.nestId,
      isChosen: true,
      name: nest.name,
      nestOrCounty: "nest" as "nest",
      parent: nest.parent,
      has_add_permission: nest.has_add_permission,
    }));
    const countiesAsOrgans: EventOrgan[] = selectedData.counties.map(
      (county) => ({
        code: county.code,
        id: county.countyId,
        isChosen: true,
        name: county.name,
        nestOrCounty: "county" as "county",
        parent: county.parent,
        has_add_permission: county.has_add_permission,
      })
    );
    this.initialSelectedOrgans = [...nestsAsOrgans, ...countiesAsOrgans];
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/create-parent-event-form-pricing-row/create-parent-event-form-pricing-row.component.ts